export class EnrolmentOnboardModel {
    hasMoreThanOneModeAvailable: boolean;
    title: string;
    message: string;
    welcomeHtml: string;
    enrollments: OnboardingEnrollment;

    constructor() {
        this.hasMoreThanOneModeAvailable = false;
        this.title = null;
        this.message = null;
        this.welcomeHtml = null;
        this.enrollments = new OnboardingEnrollment();
    }
}

export class OnboardingEnrollment {
    totalItems: number;
    totalPages: number;
    pageSize: number;
    items: Array<OnboardingEnrollmentsItem>;

    constructor() {
        this.totalItems = 0;
        this.totalPages = 0;
        this.pageSize = 0;
        this.items = new Array<OnboardingEnrollmentsItem>();
    }
}

export class OnboardingEnrollmentsItem {
    mode: string;
    name: string;
    beginDate: Date;
    enrollExpireDate: Date;
    messageForDisplay: string;
    message: string;
    welcomeMessage: string;
    disabled: boolean;

    constructor() {
        this.mode = null;
        this.name = null;
        this.beginDate = null;
        this.enrollExpireDate = null;
        this.messageForDisplay = null;
        this.message = null;
        this.disabled = false;
    }
}

export class OnboardingModeSelection {
    mode: string;

    constructor() {
        this.mode = null;
    }
}

export class EnrollmentFinalizeResponse {
    isEnrollmentAvailable: boolean;
}

export class OnboardingIntializeCriteria {
    memberAdminEventId: number;
    enrollYearRoundOptionId: number;
}